/**
 * Admin user-management client (PR D — Team view).
 *
 * As cinco rotas vivem sob /api/admin/users, e o portao nao e o mesmo nas duas
 * direcoes: **listar exige `manager`**, **escrever exige `admin`**. Quem decide
 * e o backend; a tela esconde os controles de escrita de um manager, nao a tela
 * inteira (ver o cabecalho de `hooks/useApi.ts`).
 */

import apiClient from "./client";
import type { components } from "@/types/api.generated";

export type AdminUserItem = components["schemas"]["AdminUserItem"];
export type AdminUserList = components["schemas"]["AdminUserListResponse"];
export type CreateAdminUserPayload =
  components["schemas"]["CreateAdminUserRequest"];
export type UpdateAdminUserPayload =
  components["schemas"]["UpdateAdminUserRequest"];
export type UserResponse = components["schemas"]["UserResponse"];

export async function getAdminUsers(): Promise<AdminUserList> {
  const res = await apiClient.get<AdminUserList>("/api/admin/users");
  return res.data;
}

export async function createAdminUser(
  payload: CreateAdminUserPayload,
): Promise<UserResponse> {
  const res = await apiClient.post<UserResponse>("/api/admin/users", payload);
  return res.data;
}

export async function updateAdminUser(
  userId: string,
  payload: UpdateAdminUserPayload,
): Promise<UserResponse> {
  const res = await apiClient.patch<UserResponse>(
    `/api/admin/users/${userId}`,
    payload,
  );
  return res.data;
}

export async function deleteAdminUser(userId: string): Promise<void> {
  await apiClient.delete(`/api/admin/users/${userId}`);
}

export async function kickAdminUser(userId: string): Promise<void> {
  await apiClient.post(`/api/admin/users/${userId}/kick`);
}
